export default __webpack_public_path__ + "static/media/2-1.4a64fc0f.jpg";